module.exports = __webpack_public_path__ + "static/media/avatar3.8ff8abe9.webp";